export default __webpack_public_path__ + "static/media/transfer-send-phone.b4074326.png";